

// 是否显示loading
export const SET_DATA = "SET_DATA";


export const SET_TAB_INDEX = "SET_TAB_INDEX";







// WEBPACK FOOTER //
// ./src/store/types.js